const trim = (s) => {
    return (s.charAt(0) == '#') ? s.substring(1, 7) : s 
}

const convertToRGB = (colorHex) => {
    let rgb = [];
    rgb[0] = parseInt ((trim(colorHex)).substring (0, 2), 16);
    rgb[1] = parseInt ((trim(colorHex)).substring (2, 4), 16);
    rgb[2] = parseInt ((trim(colorHex)).substring (4, 6), 16);
    return rgb;
}

const transformHex = (colorRgb) => {
    let caractersHex = "0123456789abcdef";
    let color = parseInt(colorRgb);

    if (color == 0 || isNaN(colorRgb)) return "00";

    color = Math.round (Math.min (Math.max (0, color), 255));

    return caractersHex.charAt((color - color % 16) / 16) + caractersHex.charAt(color % 16);
  }

const convertToHex = (rgb) => {
    return transformHex(rgb[0]) + transformHex(rgb[1]) + transformHex(rgb[2]);
}

export const generateSpectrumBicolor = (colorStart,colorEnd,colorCount) => {

	var start = convertToRGB (colorStart);    

	var end  = convertToRGB (colorEnd);    

	var len = colorCount;

	var alpha = 0.0;

	var spectrum = [];
	
	for (let i = 0; i < len; i++) {
		var rgb = [];
		alpha += (1.0/len);
		
		rgb[0] = start[0] * alpha + (1 - alpha) * end[0];
		rgb[1] = start[1] * alpha + (1 - alpha) * end[1];
		rgb[2] = start[2] * alpha + (1 - alpha) * end[2];

		spectrum.push(convertToHex(rgb));
	}
	return spectrum.reverse();
}

export const generateSpectrumTricolor = (colorStart, colorMedium, colorEnd, colorCount) => {
    let listColor = [];

    if(colorCount <= 2){
        listColor = [trim(colorStart), trim(colorEnd)];
    }else {
        const halfCount = Math.floor(colorCount/2);

        const firstSpectrum = generateSpectrumBicolor(colorStart, colorMedium, halfCount);
        const secondSpectrum = generateSpectrumBicolor(colorMedium, colorEnd, (colorCount - halfCount));
        
        listColor = [ ...firstSpectrum, ...secondSpectrum];
    }
    
    return listColor;
}